import type { Organization } from '@hotjar/organization';
import type { Site } from '@hotjar/site';
import type { OrganizationsListItem } from './Organization/types';

export const addSitesToOrganizations = (
  organizations: Organization[] = [],
  sites: Site[] = [],
  filter = '',
): OrganizationsListItem[] => {
  const trimString = (str: string): string =>
    str
      .split(' ')
      .filter((word) => word.trim())
      .join('');
  const regexMatcher = new RegExp(trimString(filter), 'gi');
  const sort = (a: { name: string }, b: { name: string }) =>
    a.name.localeCompare(b.name, 'en', { sensitivity: 'base' });

  return organizations
    .map((organization) => ({
      ...organization,
      sites: sites
        .filter(({ organizationId }: Site) => organizationId === organization.id)
        .filter((site: Site) => {
          if (!filter) {
            return true;
          }
          const searchString = `${trimString(organization.name)}${trimString(site.name)}`;
          return searchString.match(regexMatcher);
        })
        .sort(sort),
    }))
    .filter((organization) => {
      if (organization.sites.length) {
        return true;
      }
      return trimString(organization.name).match(regexMatcher);
    })
    .sort(sort);
};
